export default "__VITE_ASSET__8a3e32b2__"